import { useEffect, useRef } from "react";

import styled from "styled-components/macro";

import FnrButton, { ButtonIcon, ButtonText } from "UI/FnrButton3";
import FnrInput from "UI/FnrInput2";
import { useFnrScreen } from "UI/FnrScreens";
import { colors } from "UI/colors";

import { Subtitle } from "../../";

export default function Title({
  title,
  setTitle,
  willShowFundItNext,
  saveNewSignup,
  isLoading,
  setTab,
}) {
  const { isAnimatedIn } = useFnrScreen();

  const titleRef = useRef();

  useEffect(() => {
    if (isAnimatedIn) titleRef.current.focus();
  }, [isAnimatedIn]);

  const buttonClick = () => {
    if (title.length < 2) return;
    if (willShowFundItNext) setTab("fundit");
    else saveNewSignup();
  };

  return (
    <Wrapper>
      <Subtitle>What should we call this Signup?</Subtitle>
      <FnrInput
        label="Signup Title"
        value={title}
        setValue={setTitle}
        ref={titleRef}
        onEnter={buttonClick}
        data-cy="NewSignup_TitleInput"
      />
      <ButtonHolder>
        <FnrButton
          disabled={title.length < 2}
          color="blue"
          onClick={buttonClick}
          loading={!willShowFundItNext && isLoading}
        >
          {willShowFundItNext ? (
            <>
              <ButtonText>Next</ButtonText>
              <ButtonIcon fas fa-chevron-right />
            </>
          ) : (
            "Let's Go"
          )}
        </FnrButton>
      </ButtonHolder>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: 24px;
`;

const ButtonHolder = styled.div`
  display: flex;
  justify-content: flex-end;
  padding-top: 24px;
`;
